import React from "react";
import {auth} from "./auth";
import {Route} from "react-router-dom";
import {oAuthCodeUrl} from "../router/paths";

// export const PrivateRoute = ({component: Component, permissions: type, ...rest}) => {
//     if (!auth.isAuthenticated()) {
//         console.log("private route !auth")
//         sessionStorage.setItem('path', window.location);
//         window.location = oAuthCodeUrl;
//         return <div/>
//     }
//     return <Route {...rest} render={(props) => <Component {...props} {...rest} />}/>
// }

export const PrivateRoute = ({component: Component, path, permissions = [], ...rest}) => {
    sessionStorage.setItem('path', window.location.href)

    if (!auth.isAuthenticated()) {
        window.location.href = oAuthCodeUrl
        return <div/>
    }
    return  <Route {...rest} render={(props) => <Component {...props} {...rest} />}/>
}